import { FC } from 'react';
import dateDiff from '@scale/shared/timeUtils';
import { TaskHeader } from '@scale/scaleui';

type OldInfoAutosaveProps = { lastAutosaveTime: Date; autosaveEnabled: boolean; visible?: boolean };

export const OldInfoAutosave: FC<OldInfoAutosaveProps> = ({
  autosaveEnabled,
  lastAutosaveTime,
  visible,
}) => {
  if (!autosaveEnabled || !lastAutosaveTime) return null;

  let secsSinceAutosave: number | undefined = undefined;
  let minsSinceAutosave: number | undefined = undefined;
  if (lastAutosaveTime) {
    secsSinceAutosave = dateDiff(new Date(), lastAutosaveTime, 'seconds');
    if (secsSinceAutosave) minsSinceAutosave = Math.floor(secsSinceAutosave / 60);
  }

  const getLastSave = () => {
    if (minsSinceAutosave && minsSinceAutosave > 0) {
      return `${minsSinceAutosave} ${minsSinceAutosave === 1 ? 'minute' : 'minutes'} ago`;
    }

    if (secsSinceAutosave && secsSinceAutosave > 5) {
      return 'A few seconds ago';
    }

    return 'Just now!';
  };

  return (
    <TaskHeader.InfoHandlerItem visible={visible} title="Autosaved">
      {getLastSave()}
    </TaskHeader.InfoHandlerItem>
  );
};
